import React from 'react';

import { cn } from 'src/utils';

interface MainLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
}

const MainLayout = ({ children, className }: MainLayoutProps) => {
    return (
        <main
            className={cn(
                'relative flex flex-1 flex-col gap-4 sm:gap-6',
                className,
            )}
        >
            {children}
        </main>
    );
};

export default MainLayout;
